// Here we will create dark and light theme variables

export const lightTheme = {

    body:"#FCF6F4",
    text:"#000000",
    fontFamily:"'Gloria Hallelujah', cursive",
    bodyRgba : "252, 246, 244",
    textRgba:"0,0,0",
}

export const DarkTheme = {

    body:"#000000",
    text:"#FCF6F4",
    fontFamily:"'Gloria Hallelujah', cursive",
    textRgba : "252, 246, 244",
    bodyRgba:"0,0,0",
}

export const GrayTheme = {
    body:"#666069",
    text:"#000000",
    fontFamily:"'Gloria Hallelujah', cursive",
}
